import { Link } from '@online-webinar/router';
import { useTranslation } from 'react-i18next';

export const WebinarsListNav = ({ page }: { page: 'upcoming' | 'on-demand' }) => {
    const { t } = useTranslation();

    return (
        <nav className="border-b border-primary flex justify-center">
            <Link
                to="/upcoming"
                className={`nav-tab-border ${page === 'upcoming' ? 'nav-tab--active' : ''}`}
                aria-current={page === 'upcoming' ? 'page' : undefined}
            >
                {t('Pages.Organized.TabUpcoming')}
            </Link>
            <Link
                to="/on-demand"
                className={`nav-tab-border ${page === 'on-demand' ? 'nav-tab--active' : ''}`}
                aria-current={page === 'on-demand' ? 'page' : undefined}
            >
                {t('Pages.Organized.TabOnDemand')}
            </Link>
        </nav>
    );
};
